import '@linc-technologies/linced-common/models/custom-inflector-rules';
import '@warp-drive/ember/install';
import '@phosphor-icons/web/duotone';
import '@phosphor-icons/web/bold';
import '@phosphor-icons/web/fill';
import Application from '@ember/application';
import Resolver from 'ember-resolver';
import loadInitializers from 'ember-load-initializers';
import config from './config/environment';
import { setConfig as setBasicDropdownConfig } from 'ember-basic-dropdown/config';
import { importSync, isDevelopingApp, macroCondition } from '@embroider/macros';

import setupInspector from '@embroider/legacy-inspector-support/ember-source-4.12';
import compatModules from '@embroider/virtual/compat-modules';

if (macroCondition(isDevelopingApp())) {
  importSync('./deprecation-workflow');
}

// ember-basic-dropdown@9 no longer reads `APP.rootElement` itself. It uses it as
// the dropdown destination under test, where there is no wormhole element.
setBasicDropdownConfig({ rootElement: config.APP.rootElement });

export default class App extends Application {
  modulePrefix = config.modulePrefix;
  podModulePrefix = config.podModulePrefix;
  Resolver = Resolver.withModules(compatModules);
  inspector = setupInspector(this);
}

loadInitializers(App, config.modulePrefix, compatModules);
